<div class="mat-form-field-wrapper">
  @if (!showEditor || textControl?.disabled || readonly) {
    <div
      class="text-editor-view"
      [froalaView]="!(textControl?.value === null || textControl?.value === '') ? textControl.value : placeholder"></div>
  }

  @if (showEditor && textControl.enabled && !readonly) {
    <div class="text-editor-active" tabindex="-1">
      <div [formControl]="textControl" [froalaEditor]="options"></div>
    </div>
  }
</div>
